export function getEventPasswordState(passwords = [], now = new Date()) {
  const timestamp = new Date(now).getTime()
  if (passwords.some(password =>
    new Date(password.startsAt).getTime() <= timestamp && timestamp < new Date(password.expiresAt).getTime(),
  )) {
    return 'active'
  }

  return passwords.some(password => new Date(password.startsAt).getTime() > timestamp) ? 'upcoming' : 'open'
}

export function isPasswordDateRangeValid(startsAt, expiresAt) {
  return !!startsAt && !!expiresAt && new Date(startsAt).getTime() < new Date(expiresAt).getTime()
}
